import 'regenerator-runtime/runtime'
import api from "@/services/apiService"

class ReportService {

  /**
   * ดึงรายการโพย
   */
  getTickets(limit=15) {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_API_TICKET + 'ticket/' + limit)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงรายการแทง
   */
  getTicket(ticketId) {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_API_TICKET + 'ticket/' + ticketId)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ยกเลิกโพย
   */
  cancelTicket(ticketId, data) {
    return new Promise((resolve, reject) => {
      api.patch(process.env.VUE_APP_API_SUBMIT + 'ticket/' + ticketId, data)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงรายการโพยตามวันที่
   */
  getTicketsDate(params) {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_TICKET}report/ticket/${params.startDate}/${params.endDate}/created`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงรายการบัญชี
   */
  getTransactions(params) {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_MAIN}report/transaction/${params.startDate}/${params.endDate}`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงโพยจากสถานะ
   */
  getTicketWithStatus(status) {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_TICKET}report/ticket/${status}`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงโพยจากสถานะ และประเภทหวย
   */
  getTicketWithLottoIds(status, params) {
    return new Promise((resolve, reject) => {
      api.post(`${process.env.VUE_APP_API_TICKET}report/ticket/${status}/${params.startDate}/${params.endDate}`, {marketIds: params.marketIds})
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงผลหวย
   */
  getMarketResults(marketId, limit=5) {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_MAIN}market/result/${marketId}/${limit}`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ตรวจผลรางวัล
   */
  getResults(params) {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_MAIN}report/result/${params.startDate}/${params.endDate}`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงโพยผลหวย
   */
  getRoundTickets(roundId) {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_TICKET}report/result/${roundId}`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงผลหวยล่าสุด
   */
  getLastResults() {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_MAIN}report/result/last`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงยอดรอผลเดิมพัน
   */
  getWaitAmount() {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_TICKET}report/wait-amount`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงรายการงวดหวย
   */
  getRounds() {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_MAIN}report/round`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงรายการโพยตามงวด
   */
  getTicketByRoundId(roundId) {
    return new Promise((resolve, reject) => {
      api.get(`${process.env.VUE_APP_API_TICKET}report/round/${roundId}`)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }
}

export default new ReportService()
